<div>loading indra template...check modules and routes</div>